// frontend/src/components/teams/TeamMembersBadge.tsx

import { useEffect, useState } from 'react';
import { authService } from '../../services/auth.service';

const API_BASE = (import.meta.env.PROD && (import.meta.env.VITE_API_BASE_URL === 'http://localhost:8080' || !import.meta.env.VITE_API_BASE_URL)) ? '' : (import.meta.env.VITE_API_BASE_URL || 'http://localhost:8080');

export function TeamMembersBadge({ teamId }: { teamId: string }) {
  const [members, setMembers] = useState<{ id: string; full_name: string }[]>([]);

  useEffect(() => {
    authService.getAccessToken().then(async (token) => {
      const res = await fetch(`${API_BASE}/api/teams/${teamId}/members`, { headers: { Authorization: `Bearer ${token}` } });
      const data = await res.json();
      setMembers(data.members ?? []);
    });
  }, [teamId]);

  if (members.length === 0) return null;

  return (
    <div style={{ display: 'flex', gap: 6, flexWrap: 'wrap', marginTop: 8 }}>
      {members.map((m) => (
        <span key={m.id} className="lesson-badge primary">
          👤 {m.full_name}
        </span>
      ))}
    </div>
  );
}
